import { render, staticRenderFns } from "./SlyderA.vue?vue&type=template&id=55357dec&lang=pug&"
import script from "./SlyderA.vue?vue&type=script&lang=js&"
export * from "./SlyderA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports